import styled from 'styled-components';

const HouseSmartPartnersStyles = styled.section`
  position: relative;
  @media only screen and (max-width: 1200px) {
    padding: 100px 0px 0px;
  }
  .container {
    position: relative;
    max-width: 1151px;
    margin: 0 auto;
    @media only screen and (max-width: 1200px) {
      max-width: 513px;
    }
    h2 {
      text-align: center;
      margin-bottom: 30px;
    }
    .partner-list {
      position: relative;
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      list-style: none;
      justify-content: center;
      li {
        /* width: 160px; */
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 8px;
        img {
          max-width: 100%;
        }
        @media only screen and (max-width: 550px) {
          width: 160px;
        }
      }
    }
    .disclaimer {
      position: relative;
      text-align: center;
      margin: 85px 0px 100px;
      padding: 0px 25px;
      p {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        @media only screen and (max-width: 1200px) {
          &:last-child {
            margin-top: 10px;
          }
        }
        @media only screen and (max-width: 550px) {
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
  }
`;

export default HouseSmartPartnersStyles;
